// extracted by mini-css-extract-plugin
export default {"loader":"App_loader__IPVO6"};